import React, { useEffect, useState } from "react";
import Loading from "./Loading";
import { useLocation, Link } from "react-router-dom";
import shampoo_N from "../dist/img/HomeCare/Shampoo/Shampoo_SPLING_LIFT_250_N.png";
import shampoo_O from "../dist/img/HomeCare/Shampoo/Shampoo_SLEEK_LIGHT_250_O.png";
import shampoo_P from "../dist/img/HomeCare/Shampoo/Shampoo_SLEEK_MOIST_250_P.png";
import shampoo_Q from "../dist/img/HomeCare/Shampoo/Shampoo_DEEP_MOIST_250_Q.png";
import treatment_R from "../dist/img/HomeCare/Treatment/Treatment_SPRING_LIFT_200_R.png";
import treatment_S from "../dist/img/HomeCare/Treatment/Treatment_SLEEK_LIGHT_200_S.png";
import treatment_T from "../dist/img/HomeCare/Treatment/Treatment_SLEEK_MOIST_200_T.png";
import treatment_U from "../dist/img/HomeCare/Treatment/Treatment_DEEP_MOIST_200_U.png";
import stretch_puff from "../dist/img/HomeCare/OutBath Treatment/STRETCH_PUFF_V.png";
import grant_oil from "../dist/img/HomeCare/OutBath Treatment/GRANT_OIL_W.png";
import moist_care_milk from "../dist/img/HomeCare/OutBath Treatment/MOIST_CARE_MILK_X.png";
import repair_emulsion from "../dist/img/HomeCare/OutBath Treatment/REPAIR_EMULSION_Y.png";
import outbath from "../dist/img/outbath2.png";
import essence from "../dist/img/essence.png";
import bg_video from "../dist/img/output_movie.mov";
import { useHistory } from "react-router-dom";
const HomeCare = () => {
  const location = useLocation();
  const { answer1_5, product1, product1_old, product2, product3, product4, product4_old, product1_2Visible } =
    location.state;
  const [loading, setLoading] = useState(true);
  const [homeCare1, setHomeCare1] = useState({});
  let history = useHistory();
  const [homeCare2, setHomeCare2] = useState({});
  const [homeCare4, sethomeCare4] = useState({});
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 4000);

    homeCareHandler();
  }, []);
  const homeCareHandler = () => {
    switch (product1.id) {
      case "A":
        setHomeCare1({ image: shampoo_N });
        break;
      case "B":
        setHomeCare1({ image: shampoo_O });
        break;
      case "C":
        setHomeCare1({ image: shampoo_P });
        break;
      case "D":
        setHomeCare1("Q");
        setHomeCare1({ image: shampoo_Q });
    }
    switch (product4.id) {
      case "J":
        setHomeCare2({ image: treatment_R });
        break;
      case "K":
        setHomeCare2({ image: treatment_S });
        break;
      case "L":
        setHomeCare2({ image: treatment_T });
        break;
      case "M":
        setHomeCare2({ image: treatment_U });
    }
    switch (product2.id) {
      case "F":
        sethomeCare4({
          image: grant_oil,
          title: "グラントオイル",
          price: "¥2,640",
          liters: "45ml",
          featureColor: "gr",
          feature: "髪色キレイ\nサラサラ",
          url: "https://flowdia.jp/new-products.html?#grantOil",
        });
        break;
      case "G":
        sethomeCare4({
          image: moist_care_milk,
          title: "モイストケアミルク",
          price: "¥3,080",
          liters: "75g",
          featureColor: "pr",
          feature: "うるおい\nまとまり",
          url: "https://flowdia.jp/new-products.html?#moistCareMilk",
        });

        break;
      case "E":
        sethomeCare4({
          image: stretch_puff,
          title: "ストレッチパフ",
          price: "¥3,300",
          liters: "120g",
          featureColor: "bl",
          feature: "ふんわり\nボリューム",
          url: "https://flowdia.jp/new-products.html?#stretchPuff",
        });
    }
  };
  return loading ? (
    <Loading />
  ) : (
    <section className="c-question p-output--v2">
      <video poster="" autoPlay loop playsInline muted>
        <source src={bg_video} type="video/mp4"></source>
      </video>

      <section className="c-question__content p-output__content--v2 c-box2 v2n">
        <h1 className="c-question__title p-output__title--v2">
          あなたの髪の記憶に最適な
          <br className="u-sp" />フローディア
        </h1>
        <table className="u-pc">
          <tr>
            {answer1_5 === "option1" &&
              <td>
                <div>
                  <img src={homeCare1.image} alt="" />
                </div>
              </td>
            }
            {answer1_5 === "option2" &&
              <td>
                <div>
                  <img src={require(`../dist/img/${product1_old.imageHomecare}`).default} alt="" />
                </div>
              </td>
            }
            {answer1_5 === "option1" &&
              <td>
                <div>
                  <img src={homeCare2.image} alt="" />
                </div>
              </td>
            }
            {answer1_5 === "option2" &&
              <td>
                <div>
                  <img src={require(`../dist/img/${product4_old.imageHomecare}`).default} alt="" />
                </div>
              </td>
            }
            {answer1_5 === "option2" &&
              <td class="ss">
                <div><span class="pk">頭皮ケア<br/>ボリュームアップ</span></div>
                <div>
                  <img src={essence} alt="" />
                </div>
              </td>
            }
            <td class="ss">
						  <div><span class="or">髪質改善<br/>うねり・くせ</span></div>
              <div>
                <img src={outbath} alt="" />
              </div>
            </td>
            <td class="ss">
						  <div><span class={homeCare4.featureColor} style={{whiteSpace:"pre-wrap"}}>{homeCare4.feature}</span></div>
              <div>
                <img src={homeCare4.image} alt="" />
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span>シャンプー</span>
            </td>
            <td>
              <span>トリートメント</span>
            </td>
            {answer1_5 === "option2" &&
              <td>
                <span>アウトバストリートメント</span>
              </td>
            }
            <td>
              <span>アウトバストリートメント</span>
            </td>
            <td>
              <span>アウトバストリートメント</span>
            </td>
          </tr>
          <tr>
            {answer1_5 === "option1" &&
              <th>{product1.title}</th>
            }
            {answer1_5 === "option2" &&
              <th>{product1_old.title}</th>
            }
            {answer1_5 === "option1" &&
              <th>{product4.title}</th>
            }
            {answer1_5 === "option2" &&
              <th>{product4_old.title}</th>
            }
            {answer1_5 === "option2" &&
              <th>リニューイングエッセンス</th>
            }
            <th>リペアエマルジョン</th>
            <th>{homeCare4.title}</th>
          </tr>
          <tr>
            <td>容量 / 価格(税込)</td>
            <td>容量 / 価格(税込)</td>
            {answer1_5 === "option2" &&
              <td>容量 / 価格(税込)</td>
            }
            <td>容量 / 価格(税込)</td>
            <td>容量 / 価格(税込)</td>
          </tr>
          <tr>
            <td>
              <div>
                <ul>
                  <li>250mL</li>
                  <li>¥2,970</li>
                </ul>
                <ul>
                  <li>450mL(詰替)</li>
                  <li>¥3,630</li>
                </ul>
                <ul>
                  <li>550mL</li>
                  <li>¥4,950</li>
                </ul>
                <ul>
                  <li>1000mL(詰替)</li>
                  <li>¥6,600</li>
                </ul>
              </div>
              {answer1_5 === "option1" &&
                <div class="btn"><a target="_blank" href={product1.url} class="c-question__btn p-output__btn--v2">製品詳細</a></div>
              }
              {answer1_5 === "option2" &&
                <div class="btn"><a target="_blank" href={product1_old.url} class="c-question__btn p-output__btn--v2">製品詳細</a></div>
              }
            </td>
            <td>
              <div>
                <ul>
                  <li>250g</li>
                  <li>¥3,190</li>
                </ul>
                <ul>
                  <li>450mL(詰替)</li>
                  <li>¥4,510</li>
                </ul>
                <ul>
                  <li>550g</li>
                  <li>¥6,600</li>
                </ul>
                <ul>
                  <li>1000mL(詰替)</li>
                  <li>¥8,140</li>
                </ul>
              </div>
              {answer1_5 === "option1" &&
                <div class="btn" tabindex="0"><a target="_blank" href={product4.url} class="c-question__btn p-output__btn--v2">製品詳細</a></div>
              }
              {answer1_5 === "option2" &&
                <div class="btn" tabindex="0"><a target="_blank" href={product4_old.url} class="c-question__btn p-output__btn--v2">製品詳細</a></div>
              }
            </td>
            {answer1_5 === "option2" &&
              <td>
                <div>
                  <ul>
                    <li>100mL</li>
                    <li>¥2,970</li>
                  </ul>
                </div>
                <div class="btn" tabindex="0">
                  <a target="_blank" href="https://flowdia.jp/agingcare_products.html?#renewingEssence" class="c-question__btn p-output__btn--v2">製品詳細</a></div>
              </td>
            }
            <td>
              <div>
                <ul>
                  <li>75g</li>
                  <li>¥3,080</li>
                </ul>
              </div>
              <div class="btn">
                  <a target="_blank" href="https://flowdia.jp/new-products.html?#repairEmulsion" className="c-question__btn p-output__btn--v2">製品詳細</a>
              </div>
            </td>
            <td>
              <div>
                <ul>
                  <li>{homeCare4.liters}</li>
                  <li>{homeCare4.price}</li>
                </ul>
              </div>
              <div class="btn"><a target="_blank" href={homeCare4.url} class="c-question__btn p-output__btn--v2">製品詳細</a></div>
            </td>
          </tr>
        </table>
        <table className="u-sp">
          {answer1_5 === "option1" &&
            <tr>
              <td>
                <span>シャンプー</span>
              </td>
              <td>
                <div>
                  <img src={homeCare1.image} alt="" />
                </div>
              </td>
              <th>{product1.title}</th>
              <td>容量 / 価格(税込)</td>
              <td>
                <div>
                  <ul>
                    <li>250mL</li>
                    <li>¥2,970</li>
                  </ul>
                  <ul>
                    <li>450mL（詰替）</li>
                    <li>¥3,630</li>
                  </ul>
                </div>
              </td>
              <td>
                <div>
                  <ul>
                    <li>550mL</li>
                    <li>¥4,950</li>
                  </ul>
                  <ul>
                    <li>1000mL（詰替）</li>
                    <li>¥6,600</li>
                  </ul>
                </div>
                <div class="btn" tabindex="0"><a target="_blank" href={product1.url} class="c-question__btn p-output__btn--v2">製品詳細</a></div>
              </td>
            </tr>
          }
          {answer1_5 === "option2" &&
            <tr>
              <td>
                <span>シャンプー</span>
              </td>
              <td>
                <div>
                  <img src={require(`../dist/img/${product1_old.imageHomecare}`).default} alt="" />
                </div>
              </td>
              <th>{product1_old.title}</th>
              <td>容量 / 価格(税込)</td>
              <td>
                <div>
                  <ul>
                    <li>250mL</li>
                    <li>¥2,970</li>
                  </ul>
                  <ul>
                    <li>450mL（詰替）</li>
                    <li>¥3,630</li>
                  </ul>
                </div>
              </td>
              <td>
                <div>
                  <ul>
                    <li>550mL</li>
                    <li>¥4,950</li>
                  </ul>
                  <ul>
                    <li>1000mL（詰替）</li>
                    <li>¥6,600</li>
                  </ul>
                </div>
                <div class="btn" tabindex="0"><a target="_blank" href={product1_old.url} class="c-question__btn p-output__btn--v2">製品詳細</a></div>
              </td>
            </tr>
          }
          {answer1_5 === "option1" &&
            <tr>
              <td>
                <span>トリートメント</span>
              </td>
              <td>
                <div>
                  <img src={homeCare2.image} alt="" />
                </div>
              </td>
              <th>{product4.title}</th>
              <td>容量 / 価格(税込)</td>
              <td>
                <div>
                  <ul>
                    <li>200g</li>
                    <li>¥3,190</li>
                  </ul>
                  <ul>
                    <li>450g（詰替）</li>
                    <li>¥4,510</li>
                  </ul>
                </div>
              </td>
              <td>
                <div>
                  <ul>
                    <li>550g</li>
                    <li>¥6,600</li>
                  </ul>
                  <ul>
                    <li>1000g（詰替）</li>
                    <li>¥8,140</li>
                  </ul>
                </div>
                <div class="btn" tabindex="0"><a target="_blank" href={product4.url} class="c-question__btn p-output__btn--v2">製品詳細</a></div>
              </td>
            </tr>
          }
          {answer1_5 === "option2" &&
            <tr>
              <td>
                <span>トリートメント</span>
              </td>
              <td>
                <div>
                  <img src={require(`../dist/img/${product4_old.imageHomecare}`).default} alt="" />
                </div>
              </td>
              <th>{product4_old.title}</th>
              <td>容量 / 価格(税込)</td>
              <td>
                <div>
                  <ul>
                    <li>200g</li>
                    <li>¥3,190</li>
                  </ul>
                  <ul>
                    <li>450g（詰替）</li>
                    <li>¥4,510</li>
                  </ul>
                </div>
              </td>
              <td>
                <div>
                  <ul>
                    <li>550g</li>
                    <li>¥6,600</li>
                  </ul>
                  <ul>
                    <li>1000g（詰替）</li>
                    <li>¥8,140</li>
                  </ul>
                </div>
                <div class="btn" tabindex="0"><a target="_blank" href={product4_old.url} class="c-question__btn p-output__btn--v2">製品詳細</a></div>
              </td>
            </tr>
          }
          {answer1_5 === "option2" &&
            <tr>
              <td>
                <span>アウトバストリートメント</span>
              </td>
              <td class="ss">
						    <div><span class="pk">頭皮ケア<br/>ボリュームアップ</span></div>
                <div>
                  <img src={essence} alt="" />
                </div>
              </td>
              <th>リニューイングエッセンス</th>
              <td>容量 / 価格(税込)</td>
              <td>
                <div>
                  <ul>
                    <li>100mL</li>
                    <li>¥2,970</li>
                  </ul>
                </div>
                <div class="btn" tabindex="0"><a target="_blank" href="https://flowdia.jp/agingcare_products.html?#renewingEssence" class="c-question__btn p-output__btn--v2">製品詳細</a></div>
              </td>
            </tr>
          }
          <tr>
            <td>
              <span>アウトバストリートメント</span>
            </td>
            <td class="ss">
              <div><span class="or">髪質改善<br/>うねり・くせ</span></div>
              <div>
                <img src={outbath} alt="" />
              </div>
            </td>
            <th>リペアエマルジョン</th>
            <td>容量 / 価格(税込)</td>
            <td>
              <div>
                <ul>
                  <li>75g</li>
                  <li>¥3,080</li>
                </ul>
              </div>
              <div class="btn" tabindex="0"><a target="_blank" href="https://flowdia.jp/new-products.html?#repairEmulsion" class="c-question__btn p-output__btn--v2">製品詳細</a></div>
            </td>
          </tr>
          <tr>
            <td>
              <span>アウトバストリートメント</span>
            </td>
            <td class="ss">
              <div><span class={homeCare4.featureColor} style={{whiteSpace:"pre-wrap"}}>{homeCare4.feature}</span></div>
              <div>
                <img src={homeCare4.image} alt="" />
              </div>
            </td>
            <th>{homeCare4.title}</th>
            <td>容量 / 価格(税込)</td>
            <td>
              <div>
                <ul>
                  <li>{homeCare4.liters}</li>
                  <li>{homeCare4.price}</li>
                </ul>
              </div>
              <div class="btn" tabindex="0"><a target="_blank" href={homeCare4.url} class="c-question__btn p-output__btn--v2">製品詳細</a></div>
            </td>
          </tr>
        </table>
<div style={{display:"flex", gridTemplateColumns:"1fr 2fr", gridColumnGap:"2px"}} > 
<Link to={{pathname: "/output", state: {"backAnswer1_5":answer1_5}}} className="c-question__btn2 p-output__btn--v2">
BACK
</Link>
<Link to="/" className="c-question__btn2 p-output__btn--v2">
カウンセリングTOP
</Link>


</div>
    
     
      </section>
    </section>
  );
};

export default HomeCare;
